import React from "react";
import PropTypes from "prop-types";
import { Flex, FlexItem, Button, Small } from "orcs-design-system";
import { DEFAULT_PAGINATION_LIMIT } from "../consts";

const PaginationControls = ({ pagination, onPageChange, loading = false }) => {
  const {
    limit = DEFAULT_PAGINATION_LIMIT,
    offset = 0,
    totalCount,
  } = pagination || {};

  const startItem = offset + 1;
  const endItem = Math.min(offset + limit, totalCount);

  const canGoPrevious = offset > 0;
  const canGoNext = offset + limit < totalCount;

  const handlePrevious = () => {
    if (canGoPrevious && !loading) {
      onPageChange(Math.max(0, offset - limit));
    }
  };

  const handleNext = () => {
    if (canGoNext && !loading) {
      onPageChange(offset + limit);
    }
  };

  // Hide pagination if there are no tags or if total count is not more than the limit
  if (totalCount === 0 || totalCount <= limit) {
    return null;
  }

  return (
    <Flex alignItems="center" gap="s">
      <FlexItem>
        <Small color="greyDark">
          Showing {startItem}–{endItem} of {totalCount}
        </Small>
      </FlexItem>

      <FlexItem>
        <Flex gap="s">
          <Button
            type="button"
            variant={canGoPrevious ? "primary" : "borderGrey"}
            small
            onClick={handlePrevious}
            disabled={!canGoPrevious || loading}
            data-testid="pagination-prev"
          >
            Prev
          </Button>
          <Button
            type="button"
            variant={canGoNext ? "primary" : "borderGrey"}
            small
            onClick={handleNext}
            disabled={!canGoNext || loading}
            data-testid="pagination-next"
          >
            Next
          </Button>
        </Flex>
      </FlexItem>
    </Flex>
  );
};

PaginationControls.propTypes = {
  pagination: PropTypes.shape({
    limit: PropTypes.number.isRequired,
    offset: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired,
  }).isRequired,
  onPageChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default PaginationControls;
